import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchdatasss = (add: any) => ({
    type: 'FETCH_ADD_SUCCESS',
    payload: add,
});
export const fetchDocData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid};
            const apiname = SUPRIVISOR_API.sdoc;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const UploadImageData = (fileToUpload:any,uid:any,description:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            // const payload = {document:fileToUpload,uid:uid};
            const apiname = SUPRIVISOR_API.adddoc;
            //create form data and append the file
            const formData = new FormData();
            const filename = `${uid}-${description}-${fileToUpload}`;
            formData.append('fileToUpload',fileToUpload,filename);
            const response = await LoginService.uploadimage(apiname,formData);
            dispatch(fetchdatasss(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};